import { render, staticRenderFns } from "./error-page.mpx?vue&type=template&id=7a1171b3&scoped=true&component=true&componentId=error-pagebda7909e"
import script from "./error-page.mpx?vue&type=script&lang=js&component=true&componentId=error-pagebda7909e"
export * from "./error-page.mpx?vue&type=script&lang=js&component=true&componentId=error-pagebda7909e"
import style0 from "./error-page.mpx?vue&type=style&index=0&id=7a1171b3&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mbda7909e%22%7D&component=true&componentId=error-pagebda7909e"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1171b3",
  null
  
)

export default component.exports